import React from 'react';
import { createStructuredSelector } from 'reselect';
import { connect } from 'react-redux';
import { TableCell } from 'semantic-ui-react';
import { AppState } from 'services/types';
import { SprayEventForSubmission } from 'services/sprayEventsForSubmission/types';
import { makeSelectVariety } from './selectors';

export interface OwnProps {
    sprayEventId: SprayEventForSubmission['id'];
}

interface ConnectedProps {
    varieties?: string | null;
}

type Props = OwnProps & ConnectedProps;

export class RenderSubmissionSprayEventsTableRowVarietyCellComponent extends React.PureComponent<
    Props
> {
    render(): React.ReactElement {
        const { varieties } = this.props;

        return (
            <TableCell textAlign="left" className="events-table-cell-padding">
                {varieties}
            </TableCell>
        );
    }
}

const mapStateToProps = createStructuredSelector<
    AppState,
    OwnProps,
    ConnectedProps
>({
    varieties: makeSelectVariety()
});

export default connect(mapStateToProps)(
    RenderSubmissionSprayEventsTableRowVarietyCellComponent
);
